export const THEME_COLORS = {
  brandPink: '#F63690',
  lightPink: '#FBE1ED',
  lightGrey: '#D9D7D8',
  headerWhite: '#FFFFFF',
};
